import { ChartContainer } from '../../shared/ChartContainer';
import { EmptyState } from '../../shared/EmptyState';
import type { FpEmergingRegionRow } from '../../../../types/analytics.types';

type EmergingRegionsTableProps = {
  regions: FpEmergingRegionRow[];
  minVolume: number;
};

const TITLE = 'Emerging Regions';
const SUBTITLE = 'States with fast-growing search demand';

export const EmergingRegionsTable = ({ regions, minVolume }: EmergingRegionsTableProps) => {
  if (regions.length === 0) {
    return (
      <ChartContainer title={TITLE} subtitle={SUBTITLE}>
        <EmptyState
          message={`No regions grew ≥20% (with at least ${minVolume} searches) for the selected filters.`}
        />
      </ChartContainer>
    );
  }

  return (
    <ChartContainer title={TITLE} subtitle={SUBTITLE}>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-gray-200 text-xs font-medium uppercase tracking-wider text-gray-500">
              <th className="py-2 px-3 text-left">State</th>
              <th className="py-2 px-3 text-right">Searches</th>
              <th className="py-2 px-3 text-right">Prev</th>
              <th className="py-2 px-3 text-right">Growth</th>
            </tr>
          </thead>
          <tbody>
            {regions.map((r) => (
              <tr key={r.stateCode} className="border-b border-gray-100 hover:bg-gray-50">
                <td className="py-2 px-3 font-medium text-gray-900">{r.stateCode}</td>
                <td className="py-2 px-3 text-right text-gray-900">
                  {r.currentSearches.toLocaleString('en-US')}
                </td>
                <td className="py-2 px-3 text-right text-gray-500">
                  {r.previousSearches.toLocaleString('en-US')}
                </td>
                <td className="py-2 px-3 text-right">
                  {r.isNew ? (
                    <span className="text-[10px] font-semibold uppercase tracking-wide bg-emerald-100 text-emerald-700 px-1.5 py-0.5 rounded">
                      New
                    </span>
                  ) : (
                    <span className="font-medium text-emerald-600">▲ {r.growthPct}%</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </ChartContainer>
  );
};
